import React, { useState, useEffect } from 'react';
import { Container, Alert, Table, Button } from 'react-bootstrap';
import { useNavigate, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { apiUrl } from '../../../../util/Api';
import { useSelector } from 'react-redux';
import { getUserAccounts } from '../../../../app/slices/UserSlice';

const GuardrailBtn = (props) => {

    let { accountKey, appKey } = useParams();

    let sampleId = props?.sampleId != "" ? props.sampleId : null;
    let typeId = props?.typeId != "" ? props.typeId : null;
    let classStyles = props?.classStyles ? props.classStyles : '';

    const [guardrail, setGuardrail] = useState(null);
    const [buttonType, setButtonType] = useState(null);

    //if (sampleId == null || typeId == null) { return null }

    const currUserAccounts = useSelector(getUserAccounts);
    const currUserAccount = currUserAccounts.find(a => a.accountKey === accountKey);
    const currRoleId = currUserAccount ? currUserAccount.roleId : 0;

    let navigate = useNavigate();

    //if current role is < 2, show view guardrail btn, otherwise show create or manage

    /*
    if(currRoleId < 2) {
        return (
            <div>View guardrail</div>
        )
    }
    */

    useEffect(() => {

        let options = {
            accountKey: accountKey,
            appKey: appKey,
            sampleId: sampleId,
            typeId: typeId
        }
        let isAuthError = false;

        axios.post(apiUrl + '/guardrails/check',
            options, { withCredentials: true })
            .then((res) => {
                if (res.data.status === 'ok') {
                    if (res.data.alert !== null) {
                        setGuardrail(res.data.alert);
                        //if (currRoleId > 1) {
                            setButtonType('manage')
                        //} else {
                        //    setButtonType('view')
                        //}
                    }
                } else {

                    let redirectToLogin = false;
                    res.data.errors.forEach((error, i) => {
                        switch (error) {
                            case 'auth-expired':
                            case 'auth-error':
                            case 'no-auth':
                            case 'no-valid-account':
                            case 'no-permissions':
                                //console.log('auth expired');
                                isAuthError = true;
                                redirectToLogin = true;
                                break;
                            case 'no-results':
                                //show create btn if right permission 
                                if (currRoleId > 1) {
                                    //allow showing button to generate awareness, and hopefully get folks to sign up / pay
                                    let recordCount = res?.data?.recordCount ? res.data.recordCount : 0;
                                    //if(currUserAccount.alertLimit > recordCount){
                                        setButtonType('create')
                                    //}
                                }
                                break;
                            default:
                            //ignore
                        }
                    });
                    //don't call setErrors if not logged in as it throws an unmounted error
                    if (redirectToLogin) {
                        navigate('/login');
                        return;
                    }
                }
            })
            .catch((err) => {

            });
    }, [accountKey, appKey, navigate])


    const DisplayButton = (props) => {
        let type = props.type;
        let alert = props.guardrail;
        let classStyles = props.classStyles ? props.classStyles : '';

        switch (type) {
            case 'create':
                return (
                    <Link to={`/account/${accountKey}/guardrails/app/${appKey}/add?sampleId=${sampleId}&typeId=${typeId}`} className={`btn btn-theme btn-md ${classStyles}`}>create guardrail</Link>
                )
                break;
            case 'manage':
                return (
                    <Link to={`/account/${accountKey}/guardrails/app/${appKey}/detail/${alert.alertId}`} className={`btn btn-theme btn-md ${classStyles}`}>manage guardrail</Link>
                )
                break;
            case 'view':
                return (
                    <Link to={`/account/${accountKey}/analytics/app/${appKey}/guardrails/?alertId=${alert.alertId}`} className={`btn btn-theme btn-md ${classStyles}`}>View Guardrail</Link>
                )
                break;
            default:
                return null
        }
    }

    return (
        <DisplayButton type={buttonType} guardrail={guardrail} classStyles={classStyles}/>
    )
}

export default GuardrailBtn